module.exports = __webpack_public_path__ + "img/media-pic-1.61b476e2.png";